import React,{Component} from 'react';
import { ref } from '../config/constants'



class OrderFields2 extends Component{
    constructor(){
        super();
        this.handleChange = this.handleChange.bind(this)
        this.state ={
            BendedPrice :{},
            order:{}
        }
        
    }

    componentDidMount(){
        let category = ref.child("BendedPrice").orderByChild('status').equalTo('Active');
            category.on("value", function(snap){
                this.setState({
                    BendedPrice : snap.val()
                })
            }.bind(this))

        let setOrder ={
            number : 0,
            thickness : "",
            dimension : "",
            length : "",
            color : ""
        }       
            this.setState({
                order : setOrder
            })
    }

    handleChange(e){

        let order = this.state.order
        let update={
            ...order,
            [e.target.name] : e.target.value
        }
        this.setState({
            order : update
        })

    }
    
    componentDidUpdate(prevProps,prevState){
        if(prevState.order !== this.state.order){
            let order = this.state.order
           this.props.setData2(order.number,order.thickness,order.dimension,order.length,order.color,this.props.index)
        }

    }

    render() {

        return (
            
                <tr>
                    <td>
                        <input className="form-control "  name="number" ref="number" value = {this.state.order.number} type="text" required onChange={this.handleChange}/>                            
                    </td>
                        
                    <td>
                        <p> SHTS</p>
                    </td>
                        
                    <td>
                        <select className="form-control" name="thickness" ref="thickness" onChange={this.handleChange}>
                            <option>Select Thickness</option>
                            <option value="0.4MM">0.4MM</option>
                            <option value="0.5MM">0.5MM</option>
                            <option value="0.6MM">0.6MM</option>
                        </select>
                        x
                    </td>
                    <td>
                        <select className="form-control" name="dimension" ref="dimension" onChange={this.handleChange}>
                            <option>Select Dimension</option>
                            { 
                                this.state.BendedPrice &&
                                Object.keys(this.state.BendedPrice).map(function (key){
                                    let list = this.state.BendedPrice[key]
                                    return <option value={list.dimension} key={key}> {list.dimension} </option>
                               }.bind(this))
                            }

                        </select>
                        x
                    </td>
                    <td>
                        <select className="form-control" name="length" ref="length" onChange={this.handleChange}>
                            <option>Select Length</option>
                            <option></option>
                            <option value="2.44 M">2.44 M</option>
                            <option value="4.55 M">4.55 M</option>
                        </select>
                        ,plain shts.
                    </td>
                    <td>
                        <input type="text" className="form-control" name="color" ref="color" value={this.state.order.color} onChange={this.handleChange} />                            
                    </td>
                    <td>
                        <button type="button" className="btn btn-sm btn-danger" onClick={()=>this.props.remove2(this.props.count,this.props.index)}> x </button>
                    </td>
                </tr>
            
        );
    }
}

export default  OrderFields2;



// WEBPACK FOOTER //
// ./src/components/OrderFields2.js